import React from 'react';
import { Box, Container, Typography } from '@mui/joy';
import Dashboard from '../dashboard/Dashboard.tsx';
import { Helmet } from 'react-helmet-async';

export const MobileApp = () => {
  return (
    <Dashboard>
      <Helmet>
        <title>Closet Sharer</title>
        <meta name="description" content="Automatically share your closet and make more sales." />
        <meta property="og:title" content="Poshwatch Mobile App" />
        <meta property="og:description" content="Automatically share your closet and make more sales." />
        <meta property="og:url" content="https://poshwatch.io/mobile-app" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: 8,
          gap: 4,
        }}
      >
        <video
          autoPlay
          loop
          muted
          style={{
            width: '100%',
            maxWidth: '320px',
            margin: '20px auto',
            display: 'block'
          }}
        >
          <source
            src="https://firebasestorage.googleapis.com/v0/b/alice-tools-a93f3.appspot.com/o/videos%2Fmobile-app-full.mp4?alt=media&token=ab45018c-afca-4aa6-b62e-6e3c0128b088"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <Typography level="h4" fontWeight="bold" textAlign="center">
          Download for iOS or Android
        </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
            justifyContent: 'center',
            '& > a': {
              margin: '0 8px',
            },
          }}
        >
          <Box
            component="a"
            href="https://apps.apple.com/us/app/poshwatch-reseller-tools/id6502268040?platform=iphone"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'inline-block',
              height: '60px',
              '&:hover': {
                opacity: 0.8,
              },
            }}
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
              style={{
                height: '100%',
                width: 'auto',
              }}
            />
          </Box>

          <Box
            component="a"
            href="https://play.google.com/store/apps/details?id=io.poshwatch.mobile"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'inline-block',
              height: '60px',
              '&:hover': {
                opacity: 0.8,
              },
            }}
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              style={{
                height: '100%',
                width: 'auto',
                transform: 'scale(1.47)',
              }}
            />
          </Box>
        </Box>
      </Container>
    </Dashboard>
  );
};
